<template>
  <div class="home_icon--box">
    <div class="load" v-if="showEmpty">
      <van-skeleton v-for="(item,k) in 8" :key="k" avatar row="0" avatar-size="48" />
    </div>
    <ul class="tab-head" v-else>
      <li
        class="tab-head-item"
        v-for="(item, index) in iconLists"
        :key="index"
        @click="iconToDo(index)"
      >
        <img :src="item.images" />
        <p>{{ item.title }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { setBaseUrl, gioPlatform, gioJumpType,handleJumpType } from '@/utils/tools';

export default {
  props: {
    iconLists: {
      type: Array,
      lastTime: null,
    },
    examYear: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      gioType: 1, // 用于埋点 1 点击 2曝光
      showEmpty: true,

    };
  },
  watch: {
    iconLists() {
      this.showEmpty = false;
      if (!this.iconLists?.length) return;
      this.gioEvent(this.iconLists, (this.gioType = 2));
    },
  },

  methods: {
    iconToDo(index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent(this.iconLists[index], (this.gioType = 1));
      this.lastTime = Date.now();
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      handleJumpType(this, this.iconLists[index]);
    },
    gioEvent(item, type) {
      const { title, skipType } = item;
      if (type === 1) {
        const adId = item.id;
        // 点击广告
        // eslint-disable-next-line
        gio('evar.set', 'kingArea_evar', title);
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: `${this.examYear}考研-首页-金刚区`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        const sortList = [];
        const adIdList = [];
        const adNameList = [];
        const jumpTypeList = [];
        if (!item) {
          return;
        }
        item.forEach((element) => {
          sortList.push(element.sort);
          adIdList.push(element.id);
          adNameList.push(element.title);
          // eslint-disable-next-line
          const jumpType = gioJumpType(element.skipType);
          // element.skipType === 1 ? '链接' : element.skipType === 2 ? '产品' : element.skipType === 3 ? '自定义产品列表' : element.skipType === 4 ? '产品分类列表' : element.skipType === 5 ? '套餐' : '其他';
          jumpTypeList.push(jumpType);
        });
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: `${this.examYear}考研-首页-金刚区`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adIdList.toString(), // 广告ID
          adName_var: adNameList.toString(), // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: jumpTypeList.toString(), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home_icon--box {
  padding: 0 40px;
  .load{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    ::v-deep .van-skeleton__avatar{
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
.tab-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  // margin: 0 36px;
  padding-bottom: 0;
  // overflow: auto;
  list-style-type: none;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-overflow-scrolling: touch;
}
.tab-head-item {
  display: flex;
  flex: 0 0 20%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 96px;
  margin-bottom: 22px;
  color: white;
}
.tab-head-item img {
  display: block;
  width:96px;
  height: 96px;
}

.tab-head-item p {
  width: 128px;
  height: 34px;
  color: #787878;
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  white-space: nowrap;
  text-align: center;
  @extend .ellipsis;
}
.tab-head-item .classify-icon {
  width: 100%;
  height: 95px;
  > img {
    // width: 100%;
    height: 100%;
  }
}
.WeChat-code {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-bg {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99;
  width: 662px;
  height: 826px;
  margin-top: -415px;
  margin-left: -333px;
}
.icon-bg > div {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 610px;
  height: 888px;
  margin-top: -446px;
  margin-left: -307px;
  background-image: url(../../../assets/img/loginImg/icon-bg.png);
  background-size: 100% 100%;
}
.icon-bg > div > p {
  width: 100%;
  color: #3a4159;
  font-size: 32px;
  line-height: 44px;
  text-align: center;
}
.icon-bg > div > p > span {
  color: #f5a623;
  font-size: 32px;
}
.icon-bg > div > span {
  display: block;
  width: 304px;
  height: 80px;
  margin: 64px auto;
  background-image: url(../../../assets/img/loginImg/icon-btn.png);
  background-size: 100% 100%;
  border: none;
}
.icon-bg > div > p:first-child {
  margin-top: 430px;
}
.icon-bg > div > div {
  width: 274px;
  height: 274px;
  margin: 24px auto;
  background-image: url(../../../assets/img/loginImg/icon-code.png);
  background-size: 100% 100%;
}

.icon-bg > div > div > img {
  display: block;
  width: 254px;
  height: 254px;
  margin: 0 auto;
}
.icon-bg .icon-close {
  position: absolute;
  bottom: -1px;
  left: 50%;
  z-index: 800000;
  width: 56px;
  height: 56px;
  margin-left: -30px;
}
.black {
  .home_icon--box {
    background: #2c2f34;
  }
  .tab-head-item p {
    color: #d4d5d6;
  }
}
</style>
